import { defineComponent as _defineComponent } from 'vue'
import { computed } from 'vue';
import { defineMessages } from '@/lib/i18n';
import sharedMessages from '@/lib/shared-messages';
import { store } from '@/store/index';
import { readIsFeatureEnabled } from '@/store/main/getters';


export default /*#__PURE__*/_defineComponent({
  __name: 'SecurityTab',
  setup(__props) {

const m = defineMessages({
  ipAddressRestriction: 'IPアドレス制限',
  loggedInStateRetentionPeriod: 'ログイン状態保持期間',
  samlAuthentication: 'SAML認証',
  developing: '開発中...',
});

const isEnforce2FaEnabled = computed(
  () => readIsFeatureEnabled(store)('enforce_2fa') ?? false
);

return { __sfc: true,m, isEnforce2FaEnabled, sharedMessages }
}

})